<template lang="html">


    <div>
    
    <svg id="pe_svg_logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 309 301">
    
    <path class="pe_cls-2" d="m25.84,6.74h124.16v143.26H6.74V25.84C6.74,15.3,15.3,6.74,25.84,6.74Z"/>
    <path class="pe_cls-2" d="m156.74,156.74H0V25.84C0,11.59,11.59,0,25.84,0h130.9v156.74Zm-143.26-13.48h129.79V13.48H25.84c-6.82,0-12.36,5.55-12.36,12.36v117.42Z"/>
    <path class="pe_cls-1" d="m150,6.74h124.16c10.54,0,19.1,8.56,19.1,19.1v124.16h-143.26V6.74h0Z"/>
    <path class="pe_cls-2" d="m300,156.74h-156.74V0h130.89c14.25,0,25.84,11.59,25.84,25.84v130.9Zm-143.26-13.48h129.78V25.84c0-6.82-5.55-12.36-12.36-12.36h-117.42v129.78Z"/>
    <path class="pe_cls-1" d="m6.74,150h143.26v143.26H25.84c-10.54,0-19.1-8.56-19.1-19.1v-124.16h0Z"/>
    <path class="pe_cls-2" d="m156.74,300H25.84c-14.25,0-25.84-11.59-25.84-25.84v-130.9h156.74v156.74ZM13.48,156.74v117.42c0,6.82,5.55,12.36,12.36,12.36h117.42v-129.78H13.48Z"/>
    <path class="pe_cls-2" d="m150,150h143.26v124.16c0,10.54-8.56,19.1-19.1,19.1h-124.16v-143.26h0Z"/>
    <path class="pe_cls-2" d="m274.16,300h-130.89v-156.74h156.74v130.9c0,14.25-11.59,25.84-25.84,25.84Zm-117.42-13.48h117.42c6.82,0,12.36-5.55,12.36-12.36v-117.42h-129.78v129.78Z"/>
    <path class="pe_cls-heart-ani" d="m221.63,268.54c-20.43-11.37-52.36-40.88-51.05-67.1,1.35-27.09,36.03-38.62,51.05-10.39,15.02-28.22,49.7-16.69,51.05,10.39,1.31,26.22-30.62,55.73-51.05,67.1Z"/>
    </svg>
    
    </div>
    </template>
    
    <script lang="js">
    
      export default  {
        name: 'sudoku',
      }
    
    </script>
    
    <style>.pe_cls-1{fill:rgb(255, 255, 255);}.pe_cls-2{fill:#222;}.pe_cls-heart-ani{fill:#e3000c;fill-rule:evenodd;}
                svg#pe_svg_logo {
                    background: #FFFFFF !important;
                    border: 4px solid #fff !important;
                    border-top: 2px solid #fff !important;
                    border-left: 2px solid #fff !important;
                    border-bottom: 2px solid #fff!important;
                    border-right: 0px solid #fff!important;
                    border-radius: 11px !important;
                }
                #pe_svg_logo .pe_cls-heart-ani {
                  animation: pulseHeart 3s infinite;
                }
                @keyframes pulseHeart{
                  0% {fill:#fff;}
                  50% {fill: red;}
                  100% {fill:#fff;}
                }
    </style>
    
    